import React, {Component} from 'react';
import couterpart from 'counterpart';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Dialog from 'react-bootstrap-dialog';
import { FaFilter } from 'react-icons/fa';
import DatePicker from 'react-datepicker';

import MenuComponent2 from './MenuComponent2';
import WorkOrderDataService from '../services/WorkOrderDataService';
// import WorkOrderAdditions from './WorkOrderAdditions';
import WorkOrderImages from './WorkOrderImages';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import MasterDataService from '../services/MasterDataService';
import NoteDataService from '../services/NoteDataService';

// import NoteDataService from '../services/NoteDataService';
// import WorkOrderButtons from './WorkOrderButtons';
// import UserDataService from '../services/UserDataService';
// import ItemDetailsViewById from './ItemDetailsViewById';
// import TalkDetails from './TalkDetails';

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import queryString from 'query-string'


// import ExpansionPanel from '@material-ui/core/ExpansionPanel';
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Typography from '@material-ui/core/Typography';

import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ICON_COLOR } from '../icon';
import { ITEM_TYPE_DA_INOX, ITEM_TYPE_DA_KHONG, ITEM_TYPE_LEN_DA, ITEM_TYPE_LEN_INOX, ITEM_TYPE_LEN_KHONG, STATUS_DA_HOAN_THANH, STATUS_LEN_HOAN_THANH, WO_CANCELLED, WO_SHIP_FROMVN, WO_VOBAO, WO_XI } from '../constants';
import ItemDetailsViewById from './ItemDetailsViewById';
import WebcamCapture from './WebcamCapture';
import ImageViewer from './ImageViewer';

class ShipWorkOrderPrint extends Component {
    constructor() {
        super();
        let shipDate = new Date();
        shipDate = WorkOrderUtil.convertToyyyyMMddhhmmString(shipDate);
        this.state = {
            allStatus: [],
            workOrder: {},
            sibling: [],
            workOrderId: null,
            updated: false,
            options: "",
            selectedOption: null,
            startDate: null,
            endDate: null,
            show: false,
            show2: false,
            show3: false,
            showCamera: false,
            confirmMsg: '',
            selectedError: 0,
            status: 0,
            inputOrderNo: '',
            action: 0,
            packageDate: shipDate,
            shippingImage: '',
            isPrint: false,
            errorCodes: [
                {id: 0, name: ''},
                {id: 1, name: 'Cắt/Khắc sai TK', mapTo: 54},
                {id: 2, name: 'TK sai, trả về TK', mapTo: 32},
                {id: 3, name: 'Sai size', mapTo: 54},
                {id: 4, name: 'Sai kỹ thuật', mapTo: 54},
                {id: 5, name: 'Cắt khắc sai', mapTo: 54},
                {id: 6, name: 'Bạc dộp', mapTo: 54},
                {id: 7, name: 'Quay kim không đủ, không đều', mapTo: 54},
                {id: 8, name: 'xước, mẻ, lỗ bề mặt', mapTo: 54},
                {id: 9, name: 'Lỗi Xi xi lại', mapTo: 54},
                {id: 14, name: 'Lỗi Xi đánh lại', mapTo: 54},
                {id: 11, name: 'Lỗi mối hàn', mapTo: 54},
                {id: 12, name: 'Lỗi trầy khi đóng gói', mapTo: 54},
                {id: 10, name: 'Lỗi khác', mapTo: 54},
                {id: 13, name: 'Lỗi khác (Thợ)', mapTo: 54},
            ]
        };
        this.scanInput = React.createRef();
    };

    componentDidMount () {  

        const query = queryString.parse(this.props.location.search);
        // console.log('query', query);
        if (query.caller === '0'){ //Clicked on NAV
            WorkOrderUtil.removeItem("shipOrders.woNo");
        }

        let shownConfirm = true;
        if (query.print === '1' || query.print === 1){ //Clicked on PRINT
            shownConfirm = false;
        }

        MasterDataService.retrieveAllStatus().then(data => {
            this.setState({ 
                allStatus:  data,
                orderNo: WorkOrderUtil.getItem("shipOrders.woNo")
            }, () =>{
                this.setState({ 
                    workOrderId: 0,
                    workOrder:  {},
                    show: false,
                    updated: false,
                    isPrint: shownConfirm
                }, () => {
                    this.filterWorkOrdersByNo(false)
                });
            }) 
        });

    }

    handleUpdate (){
        this.setState({
            updated: true
        });  
    }

    handleQtyChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              qty: newValue                  
            }
        }));        
    }

    handleUrgentChange(e){
        var newValue = e.target.checked? 1: 0;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              urgent: newValue                  
            }
        }));        
    }

    handleWorkerChange(e){
        var newValue = e.target.value.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              worker: newValue                  
            }
        }));        
    }

    handleCustomerNoteChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              notesFromBuyer: newValue                  
            }
        }));        
    }

    handleSpecialNoteChange(e){
        var newValue = e.target.value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              notesInternal: newValue                   
            }
        }));
    }

    handleSelectChange(e){
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        //var dd2 = String(today.getDate() + 2).padStart(2, '0');
        var MM= String(today.getMonth() + 1).padStart(2, '0'); 
        var yyyy = today.getFullYear();

        today = yyyy + '/' + MM + '/' + dd;
        //var endDate = yyyy + '/' + MM + '/' + dd2;
        var value = e.target[e.target.selectedIndex].value;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              worker: value,
              startDate: today//, 
              //endDate: endDate                   
            }
        }));
    };

    getCurrentStatus(status){
        if (this.state.allStatus === undefined || this.state.allStatus.length < 1){
            return status;
        }

        let currentStatus = this.state.allStatus.find(x => {
            return x.status === status;
        });
        return currentStatus? currentStatus.statusDescVn : status;
    }    

    handleEndDateChange(date){
        var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              endDate: sDate                   
            }
        }));
    }

    saveInfo(e){
        WorkOrderDataService.updateWorkOrder(this.state.workOrder).then(data => {
            var msg = couterpart.translate("msg_saved_info");
            if (data.message === undefined){
                if (data.ret < 1){
                    msg = couterpart.translate("msg_saved_error");
                }
            }else{
                msg = couterpart.translate("msg_saved_error");
            }
            ToastsStore.error(msg);
        });
    }

    cloneInfo(e){
        WorkOrderDataService.cloneWorkOrder(this.state.workOrder).then(data => {
            var msg = couterpart.translate("msg_clone_info");
            if (data.message === undefined){
                if (data.id < 1){
                    msg = couterpart.translate("msg_clone_error");
                }
            }else{
                msg = couterpart.translate("msg_clone_error");
            }
            ToastsStore.error(msg);
        });
    }

    getErrorDesc(id){
        let err = this.state.errorCodes.find(it => {
            return it.id == id
        })
        if (err){
            return err.name;
        }
        return id;
    }

    handleErrorChange(e){
        var value = e.target[e.target.selectedIndex].value;
        let mapStatus = 0;
        if (value == 2){
            mapStatus = 32;
        } else {
            mapStatus = 54;
        }
        console.log('mapStatus', mapStatus)

        let desc = this.getErrorDesc(value);
        this.setState({               
            selectedError: value,
            selectedErrorDesc: desc,
            status: mapStatus              
        });
    }

    renderErrorOption(error){
        return (
            <option key={error.id} value={error.id}>{error.name}</option>
        );
    }

    renderNote (note){
        return (
            <li key={note.id}> { note.note } </li>
        );
    }

    renderNotes(notes){
        if (notes === undefined || notes === null || !(notes instanceof Array)){
            return <></>
        }

        return (
            <ul>
                { notes.map(note => this.renderNote(note)) }
            </ul>
        );
    }

    renderErrors(){
        return(
        <select onChange={this.handleErrorChange.bind(this)}>
        {this.state.errorCodes !== undefined && this.state.errorCodes.map(error =>this.renderErrorOption(error))}
        </select>
        );
    }

    handleSelectStatusChange(e){
        const status = parseInt(e.target.value);
        this.setState({
            status: status                  
        });
    }    

    renderStatusListForShipping(){
        // let roleName =  'SHIPPING';

        if (this.state.allStatus === undefined || this.state.allStatus === null){
            return (<></>);
        }
        return (
            <select value={this.state.status} className="h_padding"
                onChange={this.handleSelectStatusChange.bind(this)}>
                {   
                    this.state.allStatus.filter(y =>{
                        return (y.type === 2 && (y.status === 32 || y.status === 54)) 
                    }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)
                }
            </select> 
        );
    }        

    renderOption(option){
        return (
            <option key={option.key} value={option.value}>{option.label}</option>
        );
    }

    renderWorkerByRole(){
        if (!AuthenticationService.isAdmin()){
            return (<label>{this.state.workOrder.workerFullName}</label>);
        }

        if((this.state.selectOptions ===undefined) || (this.state.selectOptions === null)){
            return (<></>);
        }
        return(
        <select defaultValue={this.state.workOrder.worker} onChange={this.handleSelectChange.bind(this)}>
        {this.state.selectOptions !== undefined && this.state.selectOptions.map(option =>this.renderOption(option))}
        </select>
        );
    }

    renderEditButtons(){
        if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
            return (<></>);
        }

        const button_save = couterpart.translate('button_save');
        const button_clone = couterpart.translate('button_clone');
        if (AuthenticationService.isAdmin()){
            return(
                <tr>
                    <td colSpan="4">
                        <button className="myButton" type="button" 
                        onClick={this.saveInfo.bind(this)}>{button_save}</button>
                    </td>
                </tr>
            );
        }else{
            return(
            <tr>
                <td colSpan="4">
                    <button className="myButton" type="button" 
                    onClick={this.saveInfo.bind(this)}>{button_save}</button>&nbsp;&nbsp;
                    <button className="myButton" type="button" 
                    onClick={this.cloneInfo.bind(this)}>{button_clone}</button>
                </td>
            </tr>
            );  
        }     
    }

    getOrderNote(note){
        let idx = note.indexOf('order_note');
        if (idx >= 0){
            let orderNote = note.substring(idx);
            let idx2 = orderNote.indexOf('->');
            if (idx2 >= 0){
                let s = orderNote.substring(idx2)
                let idx3 = s.indexOf('\n\r  ');
                if (idx3 >= 0){
                    return orderNote.substring(0, idx2 + idx3)
                }
                return orderNote
            }
            return orderNote;
        }
        return ''
    }

    // renderNotes(){
    //     if (this.state.notes === undefined){
    //         return "";
    //     }

    //     let s = "";
    //     for(let i=0; i< this.state.notes.length; i++){
    //         s += this.getOrderNote(this.state.notes[i].note) + "\r\n";
    //     }
    //     return s;
    // }    

    backToList(){
        this.props.history.push("/workOrders");
    }

    handleOrderNoChange(e){
        var value = e.target.value;
        sessionStorage.setItem("scanWorkOrder.inputOrderNo", value)
        this.setState(prevState => ({                 
            inputOrderNo: value                   
        }));
    }

    filterWorkOrdersByNo(showConfirm){   
        var no = this.state.orderNo;
        if (no === undefined || no === null){
            return;
        }


        let showAble = showConfirm

        WorkOrderDataService.scanByNo(`${no}`).then(data => {
            console.log('scanByNo',data)
            if (data !== undefined && data !== null && data.status !== undefined) {
                if (data.status === WO_CANCELLED){
                    showAble = false
                }

                this.setState({ 
                    workOrderId: data.id,
                    workOrder:  data,
                    show: showAble,
                    updated: true,
                    shipCode: data.shipCode,
                    packageDate: WorkOrderUtil.convertToDate2(data.shipAtTs),
                });
                WorkOrderDataService.retrieveSiblingOfWorkOrder(`${no}`).then(data => {
                    console.log('SIBLING', data);
                    this.setState({ 
                        sibling: data
                    });
                });

                NoteDataService.retrieveNotesByWorkOrder(data.id).then(data => {
                    console.log('NOTES', data);
                    this.setState({ 
                        notes: data
                    });
                });

                WorkOrderDataService.retrieveImage(this.state.workOrder.workOrderNo).then( data => {
                    // console.log(data);
                    this.setState({ 
                        shippingImage: data
                    });
                });
            } else {
                alert("Đơn hàng không hợp lệ.")
            }
        });
    }

    processOrder(){
        let orderNo = this.state.inputOrderNo;
        this.setState({ 
            workOrderId: 0,
            workOrder:  {},
            show: false,
            updated: false,
            orderNo: orderNo
        }, () => {
            if (this.state.orderNo !== undefined && this.state.orderNo.trim().length > 0){
                this.filterWorkOrdersByNo(this.state.isPrint)
            }
        });
    }

    printOrder(){
        if (this.state.workOrder === undefined || this.state.workOrder === null ||  this.state.workOrder.id === undefined){
            alert("Xin quét đơn hàng để in");
            return;
        }
        WorkOrderDataService.printWorkOrder(this.state.workOrder).then(data => {
            alert(data.status === "printed"? "Đã lưu vào cơ sở dữ liệu để in" : "Không thể lưu vào cơ sở dữ liệu để in");
        });
    }      

    handleKeyDown(e){
        if (e.key === 'Enter') {
            this.processOrder()
        }
    }

    handleShow() {
		this.setState({ show: true });
	}

    handleClose(){
        this.setState({ show: false, inputOrderNo: '' },
        () => {
            this.sleep(500).then(() => {
                this.scanWorkOrderNo.focus();
            })
        });
    }

    handleClose2(){
        this.setState({ show2: false },
        () => {
            this.sleep(500).then(() => {
                this.scanWorkOrderNo.focus();
            })
        });
    } 

    handleClose3(){
        this.setState({ show3: false },
        () => {
            this.sleep(500).then(() => {
                this.scanWorkOrderNo.focus();
            })
        });
    }

    handleCloseCamera(){
        this.setState({ showCamera: false },
        () => {
            this.sleep(500).then(() => {
                this.scanWorkOrderNo.focus();
            })
        });
    }

    // componentDidUpdate(){
    //     this.sleep(100).then(() => {
    //         this.scanWorkOrderNo.focus();
    //     })        
    // } 

    handleEdit(wo){     
        this.setState({ 
            workOrderId: 0,
            workOrder:  {},
            show: false,
            updated: false,
            inputOrderNo: wo.workOrderNo,
            orderNo: wo.workOrderNo
        }, () => {
            if (this.state.orderNo !== undefined && this.state.orderNo.trim().length > 0){
                this.filterWorkOrdersByNo(false)
            }
        });
    }

    checkSibbling(){
        if (this.state.sibling === undefined || this.state.sibling === null || this.state.sibling.length < 1){
            return 0;
        }

        let vobaoCount = 0;
        let shipCount = 0;
        let cancelCount = 0;

        for(let i=0; i<this.state.sibling.length; i++){
            if (this.state.sibling[i].status === 47){
                cancelCount ++;
                continue;
            }

            if (this.state.sibling[i].status !== 44 && this.state.sibling[i].status !== 45){
                return 1; //some wo not yet vo bao or ship
            }

            if (this.state.sibling[i].status === 44){
                vobaoCount ++;
            } else if (this.state.sibling[i].status === 45){
                shipCount ++;
            }
        }
        if (vobaoCount === this.state.sibling.length - cancelCount){
            return 2; //All remain are vobao
        }

        if (shipCount === this.state.sibling.length - cancelCount){
            return 3; //All remain are ship
        }

        return 4; //some are vobao and some are ship
    }    

    renderSibling() {
        if (this.state.sibling === undefined || this.state.sibling === null || !(this.state.sibling instanceof Array)){
            return (<></>);
        }
        return (
            <>
                <div className="row">
                    <div className="col-2 border-top border-left border-right border-light-gray table_header">
                        { couterpart.translate('work_order_no') }
                    </div>
                    <div className="col-2 border-top border-left border-right border-light-gray table_header">
                        { couterpart.translate('work_order_status') }
                    </div>
                    <div className="col-1 border-top border-left border-right border-light-gray table_header">
                        { couterpart.translate('work_order_quantity_s') }
                    </div>
                    <div className="col-1 border-top border-left border-right border-light-gray table_header">
                        { couterpart.translate('work_order_vobaocount') }
                    </div>
                    <div className="col-1 border-top border-left border-right border-light-gray table_header">
                        { couterpart.translate('work_order_shipcount') }
                    </div>
                    <div className="col-1 border-top border-left border-right border-light-gray table_header">
                        { couterpart.translate('work_order_errorcount') }
                    </div>
                    <div className="col-2 border-top border-left border-right border-light-gray table_header">
                        { couterpart.translate('work_order_shipping_error_detail') }
                    </div>                                        
                    <div className="col-2 border-top border-left border-right border-light-gray table_header">
                        { couterpart.translate('work_order_shipping_note') }
                    </div>                                                            
                </div>
                <div className="row" key={this.state.workOrder.id}>
                    <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                        <label className="label_link" onClick={ this.handleEdit.bind(this, this.state.workOrder) }>{this.state.workOrder.workOrderNo}</label>
                    </div>
                    <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                        <span style={{color:'red'}}>{ this.getCurrentStatus(this.state.workOrder.status) }</span>
                    </div>
                    <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                        {this.state.workOrder.qty}
                    </div>
                    <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                        {this.state.workOrder.vobaoCount}
                    </div>
                    <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                        {this.state.workOrder.shipCount}
                    </div>
                    <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                        {this.state.workOrder.errorCount}
                    </div>                                         
                    <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                        {this.state.workOrder.shippingNote}
                    </div>
                    <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                        {this.state.workOrder.shippingGhiChu}
                    </div>                                                            
                </div>
            {this.state.sibling.map((item, index) => (
                <div className="row" key={item.id}>
                    <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                        <label className="label_link" onClick={ this.handleEdit.bind(this, item) }>{item.workOrderNo}</label>
                    </div>
                    <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                        <span style={{color:'red'}}>{ this.getCurrentStatus(item.status) }</span>
                    </div>
                    <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                        {item.qty}
                    </div>
                    <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                        {item.vobaoCount}
                    </div>
                    <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                        {item.shipCount}
                    </div>
                    <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                        {item.errorCount}
                    </div>                                        
                    <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                        {item.shippingNote}
                    </div>
                    <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                        {item.shippingGhiChu}
                    </div>                                                            
                </div>
            ))}
            </>
        );
    }

    vobaoOrShipWorkOrder(){
        let wo = JSON.parse(JSON.stringify(this.state.workOrder))
        if (this.state.action === 2){
            wo.status = WO_VOBAO; // Vo bao
            wo.shipCount = 0
            wo.shippingNote = ''
            wo.vobaoCount = 1
        } else if (this.state.action === 2){
            wo.status = WO_SHIP_FROMVN; // Ship
            wo.shipCount = 1
            wo.vobaoCount = 0
            wo.shippingNote = ''
        }
        this.setState({
            workOrder:  wo,
            inputOrderNo: '',
            show: false,
            show2: false            
        }, () => {
            WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {                         
                this.filterWorkOrdersByNo(false);
            });
        });
    }

    shipOrder(){
        // alert('Change order and its work orders to shipping')
        let wo = JSON.parse(JSON.stringify(this.state.workOrder))
        wo.status = 45; // ship
        this.setState({
            workOrder:  wo,
            inputOrderNo: '',
            show: false,
            show2: false            
        }, () => {
            WorkOrderDataService.shipWorkOrder(this.state.workOrder).then(data => {                         
                this.filterWorkOrdersByNo(false);
            });
        });        
        
        this.setState({
            show: false,
            show2: false 
        });
    }

    changeWoShippingNote(){
        let wo = JSON.parse(JSON.stringify(this.state.workOrder))
        wo.shippingNote = this.state.shippingNote;
        wo.shippingGhiChu = this.state.shippingGhiChu;
        this.setState({
            workOrder:  wo           
        }, () => {
            WorkOrderDataService.changeShippingGhiChu(this.state.workOrder).then(data => {                         
                this.filterWorkOrdersByNo(false);
                this.scanWorkOrderNo.focus();
            });
        });        
    }

    changeWoShipCode(){
        let wo = JSON.parse(JSON.stringify(this.state.workOrder))
        wo.shipCode = this.state.shipCode;
        let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(this.state.packageDate);
        wo.shipDate = sDate;
        this.setState({
            workOrder:  wo           
        }, () => {
            WorkOrderDataService.changeShipCode(this.state.workOrder).then(data => {                         
                this.filterWorkOrdersByNo(false);
                this.scanWorkOrderNo.focus();
            });
        });        
    }    

    getOrderNo (){
        if (this.state.workOrder.workOrderNo === undefined || this.state.workOrder.workOrderNo === null){
            return '';
        }
        let idx = this.state.workOrder.workOrderNo.indexOf('_');
        return this.state.workOrder.workOrderNo.substring(0, idx);
    }

    onLoiClicked(){
        this.setState({
            show3: true,
            shippingNote: ''
        });
    }

    handleReprintTailChange(e){
        var newValue = e.target.checked? 1 : 0;
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder,                   
              reprintTail: newValue,
              reprintTailChecked: newValue         
            }
        }));   
    } 

    handleChangeStatus(act){
        let currentWo = JSON.parse(JSON.stringify(this.state.workOrder));
        if (currentWo.itemType == ITEM_TYPE_LEN_KHONG || currentWo.itemType == ITEM_TYPE_LEN_INOX || currentWo.itemType == ITEM_TYPE_LEN_DA){
            if (currentWo.lenStatus != STATUS_LEN_HOAN_THANH){
                alert("Đơn hàng chưa hoàn thành len. Không thể vô bao.");
                return;
            }
        }

        if (currentWo.itemType == ITEM_TYPE_DA_KHONG || currentWo.itemType == ITEM_TYPE_DA_INOX || currentWo.itemType == ITEM_TYPE_LEN_DA){
            if (currentWo.daStatus != STATUS_DA_HOAN_THANH){
                alert("Đơn hàng chưa hoàn thành da. Không thể vô bao.");
                return;
            }
        }
        // if (currentWo.status !== WO_XI && currentWo.status !== WO_VOBAO) {
        //     if (act == 2 || act == 3){
        //         alert("Trạng thái đơn hàng không hợp lệ để vô bao hoặc ship");
        //         return;
        //     }
        // }

        let chk = this.checkSibbling();
        if (act === 2){ //VO BAO CLICKED
            if (chk === 0 ){
                // alert('order with only 1 work order');
                this.setState({
                    confirmMsg: couterpart.translate("msg_all_vobao_change_confirm_1") + ' ' +  this.getOrderNo() + ' ' + couterpart.translate("msg_all_vobao_change_confirm_2"),
                    action: act,
                    show2: true
                });                 
            } 

            if (chk === 1 ){
                // alert('Co don hang chua vo bao cung nhu chua ship');
                this.dialog.show({
                    title: couterpart.translate("msg_title_confirm"),
                    body: couterpart.translate("msg_wait_vobao_ship_change_confirm") + '\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r',
                    actions: [
                        Dialog.CancelAction(),
                        Dialog.OKAction(() =>{
                            let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                            wo.status = 44; // Vo bao
                            wo.shipCount = 0
                            wo.vobaoCount = 1
                            this.setState({
                                workOrder:  wo,
                                inputOrderNo: '',
                                action: act
                            }, () => {
                                WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                                    this.handleClose();                          
                                    this.filterWorkOrdersByNo(false);
                                });
                            });
                        })
                    ],
                    bsSize: 'small',
                    onHide: (dialog) => {
                        dialog.hide()
                        console.log('closed by clicking background.')
                    }
                });                 
            }  

            if (chk === 2 ){
                // alert('Tat ca deu vo bao');
                this.setState({
                    confirmMsg: couterpart.translate("msg_all_vobao_change_confirm_1") + ' ' +  this.getOrderNo() + ' ' + couterpart.translate("msg_all_vobao_change_confirm_2"),
                    show2: true,
                    action: act
                });              
            }

            if (chk === 3 ){
                // alert('Tat ca deu ship');
                this.setState({
                    confirmMsg: couterpart.translate("msg_all_vobao_change_confirm_1") + ' ' +  this.getOrderNo() + ' ' + couterpart.translate("msg_all_vobao_change_confirm_2"),
                    show2: true,
                    action: act
                });              
            }

            if (chk === 4 ){
                // this.setState({
                //     confirmMsg: couterpart.translate("msg_all_vobao_change_confirm_1") + ' ' +  this.getOrderNo() + ' ' + couterpart.translate("msg_all_vobao_change_confirm_2"),
                //     show2: true,
                //     action: act
                // });
                // alert('Co don nhieu hon 1 don hang chua ship');
                this.dialog.show({
                    title: couterpart.translate("msg_title_confirm"),
                    body: couterpart.translate("msg_wait_vobao_ship_change_confirm") + '\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r',
                    actions: [
                        Dialog.CancelAction(),
                        Dialog.OKAction(() =>{
                            let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                            wo.status = 44; // Vo bao
                            wo.shipCount = 0
                            wo.vobaoCount = 1
                            this.setState({
                                workOrder:  wo,
                                inputOrderNo: '',
                                action: act
                            }, () => {
                                WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                                    this.handleClose();                          
                                    this.filterWorkOrdersByNo(false);
                                });
                            });
                        })
                    ],
                    bsSize: 'small',
                    onHide: (dialog) => {
                        dialog.hide()
                        console.log('closed by clicking background.')
                    }
                });                                    
            }            
        } else if (act === 3){ //SHIP CLICKED
            if (chk === 0 ){
                // alert('order with only 1 work order');
                this.dialog.show({
                    title: couterpart.translate("msg_title_confirm"),
                    body: couterpart.translate("msg_change_confirm"),
                    actions: [
                        Dialog.CancelAction(),
                        Dialog.OKAction(() =>{
                            this.shipOrder();
                        })
                    ],
                    bsSize: 'small',
                    onHide: (dialog) => {
                        dialog.hide()
                        console.log('closed by clicking background.')
                    }
                });                
            }         
            if (chk === 1 ){
                this.dialog.show({
                    title: couterpart.translate("msg_title_confirm"),
                    body: couterpart.translate("msg_ship_single_1") +  this.state.sibling.length + couterpart.translate("msg_ship_single_2"),
                    actions: [
                        Dialog.CancelAction(),
                        Dialog.OKAction(() =>{
                            let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                            wo.status = 45; // Ship
                            wo.shipCount = 1
                            wo.vobaoCount = 0                            
                            this.setState({
                                workOrder:  wo,
                                inputOrderNo: '',
                                action: act
                            }, () => {
                                WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                                    this.handleClose();                          
                                    this.filterWorkOrdersByNo(false);
                                });
                            });
                        })
                    ],
                    bsSize: 'small',
                    onHide: (dialog) => {
                        dialog.hide()
                        console.log('closed by clicking background.')
                    }
                });                
            }
            if (chk === 2 ){
                this.setState({
                    confirmMsg: couterpart.translate("msg_all_vobao_change_confirm_1") + ' ' +  this.getOrderNo() + ' ' + couterpart.translate("msg_all_vobao_change_confirm_2"),
                    show2: true,
                    action: act
                });
            }        
            if (chk === 3 ){
                // alert('Tat ca deu ship');
                this.setState({
                    confirmMsg: couterpart.translate("msg_all_ship_change_confirm"),
                    show2: true,
                    action: act
                });                
            }
            if (chk === 4 ){
                this.dialog.show({
                    title: couterpart.translate("msg_title_confirm"),
                    body: couterpart.translate("msg_ship_confirm"),
                    actions: [
                        Dialog.CancelAction(),
                        Dialog.OKAction(() =>{
                            let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                            wo.status = 45; // Ship
                            wo.shipCount = 1
                            wo.vobaoCount = 0                            
                            this.setState({
                                workOrder:  wo,
                                inputOrderNo: '',
                                action: act
                            }, () => {
                                WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                                    this.handleClose();                          
                                    this.filterWorkOrdersByNo(false);
                                });
                            });
                        })
                    ],
                    bsSize: 'small',
                    onHide: (dialog) => {
                        dialog.hide()
                        console.log('closed by clicking background.')
                    }
                });                
            }        
        } 
        else if (act === 1){//LOI CLICKED
            // this.dialog.show({
            //     title: couterpart.translate("msg_title_confirm"),
            //     body: couterpart.translate("msg_change_confirm"),
            //     actions: [
            //         Dialog.CancelAction(),
            //         Dialog.OKAction(() =>{
            //             // let sUpdater = "SHIPPING";
            //             let wo = JSON.parse(JSON.stringify(this.state.workOrder))
            //             wo.status = this.state.status
            //             wo.errorCode = this.state.selectedError
            //             this.setState({
            //                 workOrder:  wo,
            //                 inputOrderNo: '',
            //                 action: act
            //             }, () => {
            //                 WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
            //                     this.handleClose();                          
            //                     this.filterWorkOrdersByNo(false);
            //                 });
            //             });
            //         })
            //     ],
            //     bsSize: 'small',
            //     onHide: (dialog) => {
            //         dialog.hide()
            //         console.log('closed by clicking background.')
            //     }
            // }); 
        }
    }

    onLoiOKClicked(){
        this.dialog.show({
            title: couterpart.translate("msg_title_confirm"),
            body: couterpart.translate("msg_change_confirm"),
            actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() =>{
                    let wo = JSON.parse(JSON.stringify(this.state.workOrder))
                    let note = this.state.shippingNote? ': ' + this.state.shippingNote: '';
                    wo.status = this.state.status
                    wo.errorCode = this.state.selectedError
                    if (wo.errorCode == 9){ //Loi xi
                        wo.errorCount = wo.errorCount + 1
                    }
                    wo.shippingNote = this.state.selectedErrorDesc + note

                    this.setState({
                        workOrder:  wo,
                        inputOrderNo: '',
                        action: 1,
                        show3: false
                    }, () => {
                        WorkOrderDataService.updateStatusOfWorkOrder(this.state.workOrder).then(data => {
                            this.handleClose();                          
                            this.filterWorkOrdersByNo(false);
                        });
                    });
                })
            ],
            bsSize: 'small',
            onHide: (dialog) => {
                dialog.hide()
                console.log('closed by clicking background.')
            }
        }); 
    }

    handleShowCamera() {
		this.setState({ showCamera: true, show: false });
	}

    onCameraOKClicked(){
        this.setState({
            showCamera: false
        }, () => {
            WorkOrderDataService.postShipInfo(this.state.workOrderId, {
                shippingImage: this.state.shippingImage,
                shippingCode: this.workOrder.workOrderNo
            });
        });
    }

    handleShippingNoteChange(e){
        let vl = e.target.value
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder                
            },
            shippingNote: vl 
        }));  
    }

    handleShippingGhiChuChange(e){
        let vl = e.target.value
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder                
            },
            shippingGhiChu: vl 
        }));  
    }

    handleShipCodeChange(e){
        let vl = e.target.value
        this.setState(prevState => ({
            workOrder: {
              ...prevState.workOrder                
            },
            shipCode: vl 
        }));  
    }    

    renderColor(){
        if(this.state.workOrder.colorMaterial === undefined || this.state.workOrder.colorMaterial === null){
            return (
                <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
            );
        }
        if ((this.state.workOrder.colorMaterial.toUpperCase() === 'VÀNG') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU VÀNG')){
            return (
                <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor:'yellow' }}><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
            );
        }

        if ((this.state.workOrder.colorMaterial.toUpperCase() === 'HỒNG') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU HỒNG')){
            return (
                <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor:'pink' }}><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
            );
        }

        if ((this.state.workOrder.colorMaterial.toUpperCase() === 'BẠC') || (this.state.workOrder.colorMaterial.toUpperCase() === 'MÀU BẠC')){
            return (
                <div className="col-3 border-top border-left border-right border-light-gray" style={{ backgroundColor:'grey' }}><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
            );
        }
        
        return (
            <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.colorMaterial}</label></div>
        );                
    }

    renderShipto(){
        if(this.state.workOrder.shipTo === 'Úc'){
            return (
                <div className="col-10 border-top border-left border-light-gray" style={{ backgroundColor:'green' }}><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.shipTo}</label></div>
            );
        }
        
        return (
            <div className="col-10 border-top border-left border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.shipTo}</label></div>
        );                
    }

    handlePackageDateChange(date){
        this.setState({                 
            packageDate: date                   
        });
    }

    newMessage = (newMessage) => {
        WorkOrderDataService.retrieveImage(this.state.workOrder.workOrderNo).then( data => {
            console.log(data);
            this.setState({ 
                shippingImage: data,
                showCamera: false
            });
        });
    }

    renderCamera(){
        if (this.state.workOrderId == null ||  this.state.workOrderId == undefined || this.state.workOrderId <= 0){
            return (<></>);
        }

        if (this.state.workOrder.status != WO_SHIP_FROMVN && this.state.workOrder.status != WO_VOBAO){
            return (<></>);
        }
        return (<WebcamCapture workOrderId={this.state.workOrderId} workOrderNo={this.state.workOrder.workOrderNo} newMessage={this.newMessage }></WebcamCapture>);
    }             

    renderDetails () {
        if (this.state.workOrder.workOrderNo === undefined){
            return (<div>&nbsp;
            </div>)
        }
        
        return (
            <div>
                <div className="row">
                    <div className="col-8">
                        <div className="row">
                            <div className="col-4 border-top border-left border-light-gray">
                                <div className="row"><img alt="" src={"data:image/gif;base64," + this.state.workOrder.qrCode}/></div>
                                <div className="row">
                                    <label className="label_link" onClick={ this.handleEdit.bind(this, this.state.workOrder) }> {this.state.workOrder.workOrderNo} </label>
                                </div>
                            </div>
                            <div className="col-8 border-top border-left border-light-gray">
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('work_order_order_date_s') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy(this.state.workOrder.orderDate)}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('shipping_workorder_no') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{this.state.workOrder.workOrderNo}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{ couterpart.translate('work_order_worker') }</b></div>
                                    <div className="col border-left border-right border-light-gray">{this.renderWorkerByRole()}</div>
                                </div>
                                <div className="row border-bottom border-light-gray">                    
                                    <div className="col"><b>{couterpart.translate('work_order_end_date')}</b></div>
                                    <div className="col border-left border-right border-light-gray">{WorkOrderUtil.formatShortDisplayDateMMddyyyy2_1(this.state.workOrder.prodDeadlineTs) }</div>
                                </div>
                                <div className="row border-bottom border-light-gray"> 
                                    <div className="col">
                                        <label className="labelBox">{couterpart.translate('work_ngay_nhap_lieu')}</label>
                                    </div>
                                    <div className="col border-left border-right border-light-gray">
                                        <label className="labelValueBox">{
                                            WorkOrderUtil.formatShortDisplayDateMMddyyyy3(this.state.workOrder.ngayNhapLieu) 
                                        }</label>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_code')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.sku}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('shop_pcode')}</b></div>
                            <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.fullPCode}</div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_color')}</b></div>
                            { this.renderColor() }
                        </div>
                        <div className="row">
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_type')}</b></div>
                            <div className="col-3 border-top border-left border-light-gray">{this.state.workOrder.shapeDesign}</div>
                            <div className="col-1 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_quantity_s')}</b></div>
                            <div className="col-2 border-top border-left border-light-gray">{this.state.workOrder.qty}</div>
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_size')}</b></div>
                            <div className="col-3 border-top border-left border-right border-light-gray"><label style={{ 'fontSize': '20px', margin: '2px'}}>{this.state.workOrder.lengthSize}</label></div>
                        </div>
                        <div className="row">
                            <div className="col-2 border-top border-left border-light-gray"><b>{couterpart.translate('work_order_personalization')}</b></div>
                            <div className="col-4 border-top border-left border-right border-light-gray"><pre style={{ 'fontSize': '20px'}}>{this.state.workOrder.personalization}</pre></div>
                            <div className="col-6 border-right border-light-gray">
                                <div className="row">
                                    <div className="col-2 border-top border-light-gray"><b>{couterpart.translate('work_order_urgent_level')}</b></div>
                                    <div className="col-10 border-top border-left border-light-gray"><label style={{'fontSize': '20px', color:'red', margin: '2px'}}>
                                        { this.state.workOrder.isUrgentByCustomer === 1 ? 'X' : ''}</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-2 border-top border-light-gray"><b>{couterpart.translate('work_order_shipto')}</b></div>
                                    { this.renderShipto() }
                                </div>
                                <div className="row">
                                    <div className="col-2 border-top border-light-gray"><b>{couterpart.translate('work_order_special_note')}</b></div>
                                    <div className="col-10 border-top border-left border-light-gray">{this.state.workOrder.notesInternal}</div>
                                </div>
                                <div className="row">
                                    <div className="col-2 border-top border-light-gray">
                                        <label className="labelBox">{couterpart.translate('work_order_ycdb_shipping')}</label>
                                    </div>
                                    <div className="col-10 border-top border-left border-light-gray">
                                        {this.state.workOrder.ycdbShipping? this.state.workOrder.ycdbShipping : ''}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-2 border-top border-light-gray"><b>{couterpart.translate('customer_name')}</b></div>
                                    <div className="col-10 border-top border-left border-light-gray">{this.state.workOrder.customer}</div>
                                </div>                                   
                            </div>
                        </div>                                          
                        <div className="row">
                            <div className="col-4 border-top border-left border-right border-bottom border-light-gray">
                                <div className="row">
                                    <div className="col-4 border-top border-left border-light-gray">
                                        <label className="labelBox">{ couterpart.translate('work_order_status') }</label>
                                    </div>  
                                    <div className="col-8 border-top border-left border-right border-light-gray">
                                        <span style={{color:'red'}}>{ this.getCurrentStatus(this.state.workOrder.status) } </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4 border-top border-left border-light-gray">
                                        <label className="labelBox">{ couterpart.translate('work_order_itype') }</label>
                                    </div>                            
                                    <div className="col-8 border-top border-left border-right border-light-gray">
                                        { WorkOrderUtil.getItemTypeDescription(this.state.workOrder.itemType) }
                                    </div>                            
                                </div>
                                <div className="row">
                                    <div className="col-4 border-top border-left border-light-gray">
                                        <label className="labelBox">
                                            { couterpart.translate('work_order_status_len') }
                                        </label>
                                    </div>
                                    <div className="col-8 border-top border-left border-right border-light-gray">
                                        { WorkOrderUtil.getLenStatusDescription2(this.state.workOrder) }
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-4 border-top border-left border-bottom border-light-gray">
                                        <label className="labelBox">
                                            { couterpart.translate('work_order_status_da') }
                                        </label>
                                    </div>
                                    <div className="col-8 border-top border-left border-right border-bottom border-light-gray">
                                        { WorkOrderUtil.getDaStatusDescription2(this.state.workOrder) }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-9">
                                        <input type="text" name="shipCode" size="5" style={{ width: "97%", marginTop: "5px"}}
                                            defaultValue={this.state.workOrder.shipCode}
                                            onChange={this.handleShipCodeChange.bind(this)}/>
                                    </div>
                                    <div className="col-3">
                                        <Button variant="primary" onClick={this.changeWoShipCode.bind(this)} style={{ marginBottom: "10px", marginRight: "5px"}}>Save</Button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-9">
                                        <DatePicker name="packageDate" style={{ width: "100%", marginBottom: "5px"}}
                                            selected={ this.state.packageDate }
                                            dateFormat="MM/dd/yyyy hh:mm"
                                            onChange={this.handlePackageDateChange.bind(this)}/>
                                    </div>
                                    <div className="col-3">&nbsp;</div>
                                </div>
                                
                                <div className="row">&nbsp;</div>
                            </div>
                            <div className="col-7 border-top border-bottom border-light-gray">
                                <textarea name="name" className="form-control textArea" id="name" style={{ marginTop: "5px"}}
                                placeholder="Ghi chú" 
                                defaultValue={this.state.workOrder.shippingGhiChu? this.state.workOrder.shippingGhiChu : ''} 
                                onChange={this.handleShippingGhiChuChange.bind(this)} />
                            </div>
                            <div className="col-1 border-top border-right border-bottom border-light-gray">
                                <Button variant="primary" onClick={this.changeWoShippingNote.bind(this)} style={{ marginTop: "10px", marginRight: "5px"}}>Save</Button>
                            </div>                       
                        </div>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-12">
                                { this.renderSibling() }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                { this.renderNotes(this.state.notes) }
                            </div>
                        </div> 
                    </div>
                    <div className="col-4">
                        <WorkOrderImages mode="MODE_EDIT"  workOrderId={this.state.workOrderId}  largeMode={1}  
                            isUpdated={this.state.updated}/>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <ItemDetailsViewById itemSku={this.state.workOrder.sku}/>
                        </div>
                        <div className="row">
                            <div className="col-12 border-top border-left border-right border-bottom border-light-gray">
                                <div className="row">
                                    <div className="col-2 border-top border-left border-light-gray">
                                        <label className="labelBox">{ couterpart.translate('work_order_shipping_image') }</label>
                                    </div>  
                                    <div className="col-6 border-top border-left border-right border-light-gray">
                                        <ImageViewer data={this.state.shippingImage}></ImageViewer>
                                    </div>
                                </div>
                            </div>
                        </div>             
                    </div>
                </div>                
                <div className="row">
                <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{ couterpart.translate('lbl_caption_update') }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-6">
                                <span>{ couterpart.translate('shop_pcode') } : </span>
                            </div>
                            <div className="col-4">
                                { this.state.workOrder.fullPCode }
                            </div>
                        </div>                         
                        <div className="row">
                            <div className="col-6">
                                <span>{ couterpart.translate('work_order_quantity_s') } : </span>
                            </div>
                            <div className="col-4">
                                { this.state.workOrder.qty }
                            </div>
                        </div>                        
                    </Modal.Body>
                    <Modal.Footer>
                        { <Button variant="primary" onClick={this.handleChangeStatus.bind(this, 2)}>Vô bao</Button>}
                        { <Button variant="primary" onClick={this.handleChangeStatus.bind(this, 3)}>Ship</Button>}
                        { <Button variant="primary" onClick={this.onLoiClicked.bind(this)}>Lỗi</Button> }
                        { <Button variant="primary" onClick={this.handleShowCamera.bind(this)}>Camera</Button> }
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.show2} onHide={this.handleClose2.bind(this)} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{ couterpart.translate("msg_title_confirm") }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-12">
                                <span>{ this.state.confirmMsg }</span>
                            </div>
                        </div>
                        <div className="row">&nbsp;</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.shipOrder.bind(this, 3)}>Yes</Button>                        
                        <Button variant="primary" onClick={this.vobaoOrShipWorkOrder.bind(this)}>No</Button>
                        <Button variant="primary" onClick={this.handleClose2.bind(this)}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.show3} onHide={this.handleClose3.bind(this)} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{ couterpart.translate("msg_title_confirm") }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-6">
                                { this.renderErrors() }
                            </div>
                            <div className="col-6">
                                <input type="text" name="shippingNote" className="inputBox3" placeholder={couterpart.translate('label_note')}
                                    onChange={this.handleShippingNoteChange.bind(this)}  onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleShippingNoteChange(e) }, 0); }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <input type="checkbox" name="reprintTail" style={{ width: "20px"}}
                                    onChange={this.handleReprintTailChange.bind(this)}/>
                                <label>{ couterpart.translate("reprint_tail") }</label></div>
                        </div>
                        <div className="row">&nbsp;</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleClose3.bind(this)}>Cancel</Button>
                        <Button variant="primary" onClick={this.onLoiOKClicked.bind(this)}>OK</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showCamera} onHide={this.handleCloseCamera.bind(this)} backdrop="static" dialogClassName="modal-400">
                    <Modal.Header closeButton>
                        <Modal.Title>{ couterpart.translate("msg_title_camera") }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">&nbsp;</div>
                        <div className="row">
                            <div className="col-6">
                                {this.renderCamera() }
                            </div>
                        </div>
                        <div className="row">&nbsp;</div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.handleCloseCamera.bind(this)}>Close</Button>
                        {/* <Button variant="primary" onClick={this.onCameraOKClicked.bind(this)}>OK</Button> */}
                    </Modal.Footer>
                </Modal>

                <Dialog ref={(component) => { this.dialog = component }} />                 
                </div>
            </div>
        )
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }



      
    render() {
        if (!AuthenticationService.isAdmin() && 
            !AuthenticationService.isService() && 
            !AuthenticationService.isKhac() &&
            !AuthenticationService.isShipping() &&
            !AuthenticationService.isDesigner()){
            return (<div>Unauthorized access.</div>);
        }

        return (
            <div>
                <MenuComponent2/>
                <ToastsContainer store={ToastsStore} position="bottom_center" />
                <div  className="orderFilter">
                    <input type="text" value={this.state.inputOrderNo} name="scanWorkOrderNo" id="scanWorkOrderNo" autoFocus ref={ input => this.scanWorkOrderNo = input }
                        placeholder={couterpart.translate('order_no')}
                        onChange={this.handleOrderNoChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}/>
                    &nbsp;&nbsp;
                    <button className="myButton"  onClick={ this.processOrder.bind(this) }>
                    <FaFilter color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_filter')}</button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className="myButton"  onClick={ this.printOrder.bind(this) }>
                    <FaFilter color={ICON_COLOR}/>
                    &nbsp;{couterpart.translate('button_print_tail')}</button>
                </div>
                { this.renderDetails() }                              
            </div>
        );
    }
}

export default ShipWorkOrderPrint;